export class BannerMessage {
    content = '<empty message>';
    url?: string;
    backgroundColor = '#7dbc6c';
    textColor = '#fff';

    deserialize(data: any): BannerMessage {
        this.content = data.content ?? '<empty message>';
        this.url = data.url ?? undefined;
        this.backgroundColor = data.background_color ?? this.backgroundColor;
        this.textColor = data.text_color ?? this.textColor;
        return this;
    }
}
